/**
 * Woocommerce: Calculate Price
 *
 * Calculate the product price on a single product,
 * based on the width and length.
 *
 * @since 1.0.0
 */

import 'whatwg-fetch'
import { dimensionsValidation } from './DimensionsValidation'
import { numberFormat } from './NumberFormat'
import axios from 'axios'

export default () => {
  // Grab all necessary elements
  const cartForm = document.querySelector('form.cart')
  if (!cartForm) return

  const priceBar = cartForm.querySelector('.js-woo-price-bar')

  if (!priceBar) return
  if (priceBar.dataset.default === 'yes') return

  const widthInput = cartForm.querySelector('.js-woo-width')
  const lengthInput = cartForm.querySelector('.js-woo-length')
  const diameterInput = cartForm.querySelector('.js-woo-diameter')
  const rubberRadios = cartForm.querySelectorAll('.js-woo-rubber')
  const fillingRadios = cartForm.querySelectorAll('.js-woo-filling-mat-option')
  const AdditionalRadios = cartForm.querySelectorAll(
    '.js-woo-additional-product-option'
  )
  const cutterCheckbox = cartForm.querySelector('.js-woo-cutter')
  const quantityInput = cartForm.querySelector('.qty')
  const typeRadios = cartForm.querySelectorAll('.js-woo-type')
  const hiddenPrice = cartForm.querySelector('.js-hidden-price')
  const defaultSelect = cartForm.querySelector('.js-woo-default-select')
  const fillingMatOptions = cartForm.querySelector('.js-woo-filling-mat-option')
    ? cartForm.querySelectorAll('.js-woo-filling-mat-option')
    : false
  const fillingMatOption = fillingMatOptions
    ? cartForm.querySelector('.js-woo-filling-mat-option.active')
    : false
  const additionalMatOptions = cartForm.querySelector(
    '.js-woo-additional-product-option'
  )
    ? cartForm.querySelectorAll('.js-woo-additional-product-option')
    : false
  const additionalMatOption = additionalMatOptions
    ? cartForm.querySelectorAll('.js-woo-additional-product-option.active')
    : false
  const mobilePriceField = document.querySelector(
    '.js-woo-product-sticky-price'
  )
    ? document.querySelector('.js-woo-product-sticky-price')
    : false

  // Set cartButton to disabled by default
  let cartButton = cartForm.querySelector('.js-woo-cart-button')
  let cartSecondButton = document.querySelector('.js-woo-cart-second-button')
  if (cartButton) cartButton.disabled = true
  if (cartSecondButton) cartSecondButton.classList.add('disabled')

  // Make an array of elements to pass around easily
  const elements = {
    widthInput: widthInput,
    diameterInput: diameterInput,
    lengthInput: lengthInput,
    rubberCheckbox: rubberRadios,
    cutterCheckbox: cutterCheckbox,
    quantityInput: quantityInput,
    typeRadios: typeRadios,
    cartButton: cartButton,
    cartSecondButton: cartSecondButton,
    defaultSelect: defaultSelect,
    fillingMatOption: fillingMatOption,
    mobilePriceField: mobilePriceField,
    fillingCheckbox: fillingRadios,
    additionalMatOption: additionalMatOptions,
    additionalCheckbox: AdditionalRadios
  }

  // Standard values
  let width = 0
  let length = 0
  let timer = 0
  let hasRubber = 0
  let hasCutter = 0
  let quantity = quantityInput ? quantityInput.value : 1
  let validation = {}
  let fillingMat = fillingMatOption ? fillingMatOption : 0
  let additionalMat = additionalMatOption ? additionalMatOption : 0

  // Get price by diameter
  if (diameterInput && widthInput && lengthInput) {
    diameterInput.addEventListener('input', e => {
      width = e.target.value
      length = e.target.value
      clearTimeout(timer)

      timer = setTimeout(() => {
        validation = dimensionsValidation(width, length, hasRubber, cartForm)
        if (validation.status === false) {
          disableOtherFields(elements)
        }
        calculatePrice(
          validation,
          width,
          length,
          hasRubber,
          hasCutter,
          quantity,
          priceBar,
          elements,
          hiddenPrice,
          fillingMat,
          additionalMat
        )
      }, 1000)
    })
  }

  // Get price by width
  if (widthInput) {
    widthInput.addEventListener('input', e => {
      width = e.target.value
      clearTimeout(timer)
      timer = setTimeout(() => {
        validation = dimensionsValidation(width, length, hasRubber, cartForm)
        if (validation.status === false) {
          disableOtherFields(elements)
        }
        calculatePrice(
          validation,
          width,
          length,
          hasRubber,
          hasCutter,
          quantity,
          priceBar,
          elements,
          hiddenPrice,
          fillingMat,
          additionalMat
        )

        calculateRubberPrices(width, length, quantity, priceBar)

        if (fillingMatOptions)
          calculateFillingMatPrices(width, length, quantity, fillingMatOptions)
        if (additionalMatOptions)
          calculateAdditionalMatPrices(
            width,
            length,
            quantity,
            additionalMatOptions
          )
      }, 1000)
    })
  }

  // Get price by length
  if (lengthInput) {
    lengthInput.addEventListener('input', e => {
      length = e.target.value
      clearTimeout(timer)

      timer = setTimeout(() => {
        validation = dimensionsValidation(width, length, hasRubber, cartForm)
        if (validation.status === false) {
          disableOtherFields(elements)
        }
        calculatePrice(
          validation,
          width,
          length,
          hasRubber,
          hasCutter,
          quantity,
          priceBar,
          elements,
          hiddenPrice,
          fillingMat,
          additionalMat
        )

        calculateRubberPrices(width, length, quantity, priceBar)

        if (fillingMatOptions)
          calculateFillingMatPrices(width, length, quantity, fillingMatOptions)
        if (additionalMatOptions)
          calculateAdditionalMatPrices(
            width,
            length,
            quantity,
            additionalMatOptions
          )
      }, 1000)
    })
  }

  // Get price by rubber edge
  if (rubberRadios) {
    ;[...rubberRadios].map(rubberRadio => {
      rubberRadio.addEventListener('change', e => {
        hasRubber = e.target.checked
        if ((e.target.value === '1' || e.target.value === '2') && hasRubber) {
          hasRubber = e.target.value
        } else {
          hasRubber = 0
        }

        const extras = document.querySelector('.js-options-extras')
        if (extras) {
          extras.classList.remove('inactive')
          extras.classList.add('active')
        }

        validation = dimensionsValidation(width, length, hasRubber, cartForm)
        calculatePrice(
          validation,
          width,
          length,
          hasRubber,
          hasCutter,
          quantity,
          priceBar,
          elements,
          hiddenPrice,
          fillingMat,
          additionalMat
        )
      })
    })
  }

  // Get price by additional mats
  if (additionalMatOptions) {
    ;[...additionalMatOptions].map(matOption => {
      matOption.addEventListener('click', e => {
        validation = dimensionsValidation(width, length, hasRubber, cartForm)
        calculatePrice(
          validation,
          width,
          length,
          hasRubber,
          hasCutter,
          quantity,
          priceBar,
          elements,
          hiddenPrice,
          fillingMat,
          additionalMat
        )
      })
    })
  }

  // Get price by cutter
  if (cutterCheckbox) {
    cutterCheckbox.addEventListener('change', e => {
      hasCutter = e.target.checked
      if (hasCutter) {
        hasCutter = 1
      } else {
        hasCutter = 0
      }

      validation = dimensionsValidation(width, length, hasRubber, cartForm)
      calculatePrice(
        validation,
        width,
        length,
        hasRubber,
        hasCutter,
        quantity,
        priceBar,
        elements,
        hiddenPrice,
        fillingMat,
        additionalMat
      )
    })
  }

  // Get price by quantity
  quantityInput.addEventListener('input', e => {
    quantity = e.target.value

    validation = dimensionsValidation(width, length, hasRubber, cartForm)
    calculatePrice(
      validation,
      width,
      length,
      hasRubber,
      hasCutter,
      quantity,
      priceBar,
      elements,
      hiddenPrice,
      fillingMat,
      additionalMat
    )
  })

  // Get active filling mat
  if (fillingMatOption) {
    let activeFillingMatOption = []
    activeFillingMatOption.push(
      cartForm.querySelector('.js-woo-filling-mat-option.active')
    )
    ;[...fillingMatOptions].forEach(option => {
      option.addEventListener('click', e => {
        // AANPASSEN
        if (option.classList.contains('active')) {
          option.classList.remove('active')

          if (activeFillingMatOption.length > 0) {
            const indexToRemove = activeFillingMatOption.indexOf(option)
            if (indexToRemove !== -1) {
              activeFillingMatOption.splice(indexToRemove, 1)
            }
          }
        } else {
          option.classList.add('active')
          activeFillingMatOption.push(option)
        }

        // // Remove the active state
        // ;[...fillingMatOptions].forEach(item => {
        //   if (item.classList.contains('active')) item.classList.remove('active')
        // })

        // option.classList.add('active')
        // fillingMat = option

        fillingMat = activeFillingMatOption
        clearTimeout(timer)

        timer = setTimeout(() => {
          validation = dimensionsValidation(width, length, hasRubber, cartForm)
          if (validation.status === false) {
            disableOtherFields(elements)
          }
          calculatePrice(
            validation,
            width,
            length,
            hasRubber,
            hasCutter,
            quantity,
            priceBar,
            elements,
            hiddenPrice,
            fillingMat
          )
        }, 1000)
      })
    })
  }
}

function calculateFillingMatPrices(width, length, quantity, array) {
  ;[...array].forEach(option => {
    let fillingMatID = option.dataset.id
    let fillingMatPrice = 0
    let fillingMatRawPrice = 0
    let fillingMatTotalPrice = 0

    if (fillingMatID != 0) {
      axios({
        method: 'get',
        headers: {
          credentials: 'same-origin'
        },
        url: `/wp-json/mattador/v1/calculate_price/?product_id=${fillingMatID}&mattador_width=${width}&mattador_length=${length}`
      })
        .then(response => {
          const matResult = response.data
          fillingMatPrice = parseFloat(matResult.price)
          fillingMatRawPrice = (fillingMatPrice * quantity).toFixed(2)
          fillingMatTotalPrice = numberFormat(fillingMatRawPrice, 2, ',', '.')

          const fillingMatPriceContainer = option.querySelector(
            '.js-woo-filling-mat-price'
          )
          fillingMatPriceContainer.innerHTML = `€${fillingMatTotalPrice}`

          return fillingMatTotalPrice
        })
        .catch(error => {
          console.log(error)
          return (fillingMatPriceContainer.innerHTML =
            'Er is iets misgegaan. Ververs de pagina.')
        })
    }
  })
}

function calculateAdditionalMatPrices(width, length, quantity, array) {
  ;[...array].forEach(option => {
    let additionalMatID = option.dataset.id
    let additionalMatPrice = 0
    let additionalMatRawPrice = 0
    let additionalMatTotalPrice = 0
    console.log(option.dataset)
    console.log(option.dataset.parent)
    if (option.dataset.parent) return

    if (additionalMatID != 0) {
      axios({
        method: 'get',
        headers: {
          credentials: 'same-origin'
        },
        url: `/wp-json/mattador/v1/calculate_price/?product_id=${additionalMatID}&mattador_width=${width}&mattador_length=${length}`
      })
        .then(response => {
          const matResult = response.data
          additionalMatPrice = parseFloat(matResult.price)
          additionalMatRawPrice = (additionalMatPrice * quantity).toFixed(2)
          additionalMatTotalPrice = numberFormat(
            additionalMatRawPrice,
            2,
            ',',
            '.'
          )

          const additionalMatPriceContainer = option.querySelector(
            '.js-woo-additional-mat-price'
          )
          additionalMatPriceContainer.innerHTML = `€${additionalMatTotalPrice}`

          return additionalMatTotalPrice
        })
        .catch(error => {
          console.log(error)
          return (additionalMatPriceContainer.innerHTML =
            'Er is iets misgegaan. Ververs de pagina.')
        })
    }
  })
}

function calculateRubberPrices(width, length, quantity, priceBar) {
  const rubberMatPriceContainers = document.querySelectorAll(
    '.js-woo-rubber-mat-price'
  )
  const productID = priceBar.dataset.product
  let productWithRubberPrice = 0
  let productWithRubberRawPrice = 0
  let productWithoutRubberPrice = 0
  let productWithoutRubberRawPrice = 0
  let rubberTotalPrice = 0

  if (!productID) {
    return
  }

  if (rubberMatPriceContainers.length > 0) {
    axios({
      method: 'get',
      headers: {
        credentials: 'same-origin'
      },
      url: `/wp-json/mattador/v1/calculate_price/?product_id=${productID}&mattador_width=${width}&mattador_length=${length}&mattador_cutter=0&mattador_rubber=0`
    })
      .then(withoutRubberResponse => {
        const withoutRubberResult = withoutRubberResponse.data
        productWithoutRubberPrice = parseFloat(withoutRubberResult.price)
        productWithoutRubberRawPrice = (
          productWithoutRubberPrice * quantity
        ).toFixed(2)
        ;[...rubberMatPriceContainers].forEach(rubberMatPriceContainer => {
          const rubberMatValue = rubberMatPriceContainer.dataset.value

          // Calculate rubber price
          axios({
            method: 'get',
            headers: {
              credentials: 'same-origin'
            },
            url: `/wp-json/mattador/v1/calculate_price/?product_id=${productID}&mattador_width=${width}&mattador_length=${length}&mattador_cutter=0&mattador_rubber=${rubberMatValue}`
          })
            .then(withRubberResponse => {
              const rubberResult = withRubberResponse.data
              productWithRubberPrice = parseFloat(rubberResult.price)
              productWithRubberRawPrice = (
                productWithRubberPrice * quantity
              ).toFixed(2)

              // Calculate without rubber price
              rubberTotalPrice = numberFormat(
                productWithRubberRawPrice - productWithoutRubberRawPrice,
                2,
                ',',
                '.'
              )
              rubberMatPriceContainer.innerHTML = `€${rubberTotalPrice}`
            })
            .catch(error => {
              console.log(error)
            })
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
}

function calculatePrice(
  validation,
  width,
  length,
  hasRubber,
  hasCutter,
  quantity,
  priceBar,
  elements,
  hiddenPrice,
  fillingMat,
  additionalMat
) {
  // Return early if invalid entry
  if (!validation.status && elements.cartButton) {
    elements.cartButton.disabled = true
    return
  }

  // Get price elements
  const priceField = priceBar.querySelector('.js-woo-price')
  const regularPriceField = priceBar.querySelector('.js-woo-regular-price')
  const taxFields = priceBar.querySelectorAll('.js-woo-price-tax')
  let result = ''
  let singlePrice = 0
  let rawPrice = 0
  let totalPrice = 0
  let totalRawPrice = 0
  let fillingMatPrice = 0
  let fillingMatRawPrice = 0
  let fillingMatTotalPrice = 0
  let fillingMatSelectionArray = []
  let additionalMatPrice = 0
  let additionalMatRawPrice = 0
  let additionalMatTotalPrice = 0
  let additionalMatSelectionArray = []

  // Get product id
  const productID = priceBar.dataset.product
  if (!productID) {
    priceField.innerHTML =
      'Product informatie kon niet opgehaald worden. Ververs de pagina.'
    if (regularPriceField) {
      regularPriceField.innerHTML = ''
    }
    return
  }

  // Show some feedback
  priceField.innerHTML = 'Berekenen...'
  ;[...taxFields].forEach(taxField => {
    taxField.innerHTML = 'incl. btw' //removes 'vanaf'
  })
  if (regularPriceField) {
    regularPriceField.classList.add('active')
    regularPriceField.innerHTML = ''
  }

  // Temporarily disable fields
  disableFields(elements)

  // Fetch price
  axios({
    method: 'get',
    headers: {
      credentials: 'same-origin'
    },
    url: `/wp-json/mattador/v1/calculate_price/?product_id=${productID}&mattador_width=${width}&mattador_length=${length}&mattador_cutter=${hasCutter}&mattador_rubber=${hasRubber}`
  })
    .then(response => {
      result = response.data

      singlePrice = parseFloat(result.price * quantity)
      rawPrice = (singlePrice * quantity).toFixed(2)
      totalPrice = singlePrice
      totalRawPrice = singlePrice

      if (fillingMat && fillingMat.length > 1) {
        ;[...fillingMat].forEach(mat => {
          const fillingMatID = mat ? mat.dataset.id : false

          if (fillingMatID != 0) {
            axios({
              method: 'get',
              headers: {
                credentials: 'same-origin'
              },
              url: `/wp-json/mattador/v1/calculate_price/?product_id=${fillingMatID}&mattador_width=${width}&mattador_length=${length}`
            })
              .then(matResponse => {
                const matResult = matResponse.data
                fillingMatPrice = parseFloat(matResult.price)
                fillingMatRawPrice = (fillingMatPrice * quantity).toFixed(2)
                fillingMatTotalPrice = numberFormat(
                  fillingMatRawPrice,
                  2,
                  ',',
                  '.'
                )
                fillingMat = document.querySelector(
                  `.js-woo-filling-mat-option[data-id="${fillingMatID}"]`
                )

                const fillingMatPriceContainer = fillingMat.querySelector(
                  '.js-woo-filling-mat-price'
                )
                fillingMatPriceContainer.innerHTML = `€${fillingMatTotalPrice}`

                totalRawPrice =
                  fillingMat && fillingMatTotalPrice != 0
                    ? totalRawPrice + fillingMatPrice * quantity
                    : singlePrice

                totalPrice =
                  fillingMat && fillingMatTotalPrice != 0
                    ? numberFormat(totalRawPrice, 2, ',', '.')
                    : numberFormat(singlePrice, 2, ',', '.')

                priceField.innerHTML = `€${totalPrice}`
                hiddenPrice.value = totalPrice
                if (elements.mobilePriceField)
                  elements.mobilePriceField.innerHTML = `€${totalPrice}`

                const fillingMatSelection = document.querySelector(
                  '.js-woo-filling-mat-selection'
                )
                fillingMatSelectionArray.push(fillingMatID)
                fillingMatSelection.setAttribute(
                  'value',
                  JSON.stringify(fillingMatSelectionArray)
                )

                if (regularPriceField) {
                  let regularPrice = parseFloat(result.regular_price)
                  let rawRegularPrice = (regularPrice * quantity).toFixed(2)
                  regularPriceField.classList.remove('active')
                  regularPriceField.innerHTML = `€${numberFormat(
                    rawRegularPrice,
                    2,
                    ',',
                    '.'
                  )}`
                }

                // Turn fields back on
                return enableFields(elements)
              })
              .catch(error => {
                console.log(error)
                return (priceField.innerHTML =
                  'Er is iets misgegaan. Ververs de pagina.')
              })
          }
        })
      } else {
        // Set price (formatted for Dutch)
        singlePrice = parseFloat(result.price)
        rawPrice = (singlePrice * quantity).toFixed(2)
        totalPrice = numberFormat(rawPrice, 2, ',', '.')

        priceField.innerHTML = `€${totalPrice}`
        hiddenPrice.value = totalPrice
        if (elements.mobilePriceField)
          elements.mobilePriceField.innerHTML = `€${totalPrice}`

        if (regularPriceField) {
          let regularPrice = parseFloat(result.regular_price)
          let rawRegularPrice = (regularPrice * quantity).toFixed(2)
          regularPriceField.classList.remove('active')
          regularPriceField.innerHTML = `€${numberFormat(
            rawRegularPrice,
            2,
            ',',
            '.'
          )}`
        }

        // Turn fields back on
        return enableFields(elements)
      }
    })
    .then(res => {
      if (additionalMat && additionalMat.length > 0) {
        additionalMat = document.querySelectorAll(
          '.js-woo-additional-product-option.active'
        )
        ;[...additionalMat].forEach(mat => {
          const additionalMatID = mat ? mat.dataset.id : false
          if (additionalMatID != 0) {
            priceField.innerHTML = 'Berekenen...'
            disableFields(elements)
            axios({
              method: 'get',
              headers: {
                credentials: 'same-origin'
              },
              url: `/wp-json/mattador/v1/calculate_price/?product_id=${additionalMatID}&mattador_width=${width}&mattador_length=${length}`
            })
              .then(matResponse => {
                additionalMat = document.querySelector(
                  `.js-woo-additional-product-option[data-id="${additionalMatID}"]`
                )

                const additionalMatPriceContainer = additionalMat.querySelector(
                  '.js-woo-additional-mat-price'
                )
                const matResult = matResponse.data

                if (additionalMat.dataset.parent) {
                  additionalMatPrice = parseFloat(
                    additionalMatPriceContainer.dataset.price
                      .replace('€', '')
                      .replace(',', '.')
                  )
                } else {
                  additionalMatPrice = parseFloat(matResult.price)
                }

                additionalMatRawPrice = (additionalMatPrice * quantity).toFixed(
                  2
                )
                additionalMatTotalPrice = numberFormat(
                  additionalMatRawPrice,
                  2,
                  ',',
                  '.'
                )
                console.log('Price 1:')
                console.log(additionalMatPrice)
                console.log(quantity)
                console.log(additionalMatRawPrice)
                console.log(additionalMatTotalPrice)

                additionalMatPriceContainer.innerHTML = `€${additionalMatTotalPrice}`

                totalRawPrice =
                  additionalMat && additionalMatTotalPrice != 0
                    ? totalRawPrice + additionalMatPrice * quantity
                    : singlePrice

                totalPrice =
                  additionalMat && additionalMatTotalPrice != 0
                    ? numberFormat(totalRawPrice, 2, ',', '.')
                    : numberFormat(singlePrice, 2, ',', '.')

                priceField.innerHTML = `€${totalPrice}`
                hiddenPrice.value = totalPrice
                if (elements.mobilePriceField)
                  elements.mobilePriceField.innerHTML = `€${totalPrice}`

                const additionalMatSelection = document.querySelector(
                  '.js-woo-additional-product-selection'
                )
                
                if (additionalMat.dataset.parent) {
                  additionalMatSelectionArray.push(`${additionalMat.dataset.parent};${additionalMatID}`)
                } else {
                  additionalMatSelectionArray.push(additionalMatID)
                }

                additionalMatSelection.setAttribute(
                  'value',
                  JSON.stringify(additionalMatSelectionArray)
                )

                if (regularPriceField) {
                  let regularPrice = parseFloat(result.regular_price)
                  let rawRegularPrice = (regularPrice * quantity).toFixed(2)
                  regularPriceField.classList.remove('active')
                  regularPriceField.innerHTML = `€${numberFormat(
                    rawRegularPrice,
                    2,
                    ',',
                    '.'
                  )}`
                }

                // Turn fields back on
                return enableFields(elements)
              })
              .catch(error => {
                console.log(error)
                return (priceField.innerHTML =
                  'Er is iets misgegaan. Ververs de pagina.')
              })
          }
        })
      }
    })
    .catch(error => {
      console.log(error)
      return (priceField.innerHTML = 'Er is iets misgegaan. Ververs de pagina.')
    })
}

function disableOtherFields(elements) {
  if (elements.rubberCheckbox) {
    ;[...elements.rubberCheckbox].forEach(el => {
      el.disabled = true
    })
  }
  if (elements.cutterCheckbox) {
    elements.cutterCheckbox.disabled = true
  }
}

/**
 * Disable all input fields and cart button
 */
function disableFields(elements) {
  if (elements.rubberCheckbox) {
    ;[...elements.rubberCheckbox].forEach(el => {
      el.disabled = true
    })
  }
  if (elements.fillingCheckbox) {
    ;[...elements.fillingCheckbox].forEach(el => {
      el.classList.add('disabled')
    })
  }
  if (elements.additionalCheckbox) {
    ;[...elements.additionalCheckbox].forEach(el => {
      el.classList.add('disabled')
    })
  }
  if (elements.cutterCheckbox) {
    elements.cutterCheckbox.disabled = true
  }
  if (elements.widthInput) {
    elements.widthInput.disabled = true
  }
  if (elements.lengthInput) {
    elements.lengthInput.disabled = true
  }
  if (elements.quantityInput) {
    elements.quantityInput.disabled = true
  }
  if (elements.cartButton) {
    elements.cartButton.disabled = true
  }
  if (elements.cartSecondButton) {
    elements.cartSecondButton.classList.add('disabled')
  }
  if (elements.typeRadios) {
    ;[...elements.typeRadios].forEach(radio => {
      radio.disabled = true
    })
  }
  if (elements.defaultSelect) {
    elements.defaultSelect.disabled = true
  }
}

/**
 * Enable all input fields and cart button
 */
function enableFields(elements) {
  if (elements.rubberCheckbox) {
    ;[...elements.rubberCheckbox].forEach(el => {
      el.disabled = false
    })
  }
  if (elements.fillingCheckbox) {
    ;[...elements.fillingCheckbox].forEach(el => {
      el.classList.remove('disabled')
    })
  }
  if (elements.additionalCheckbox) {
    ;[...elements.additionalCheckbox].forEach(el => {
      el.classList.remove('disabled')
    })
  }
  if (elements.cutterCheckbox) {
    elements.cutterCheckbox.disabled = false
  }
  if (elements.widthInput) {
    elements.widthInput.disabled = false
  }
  if (elements.lengthInput) {
    elements.lengthInput.disabled = false
  }
  if (elements.quantityInput) {
    elements.quantityInput.disabled = false
  }
  if (elements.cartButton) {
    elements.cartButton.disabled = false
  }
  if (elements.cartSecondButton) {
    elements.cartSecondButton.classList.remove('disabled')
  }
  if (elements.typeRadios) {
    ;[...elements.typeRadios].forEach(radio => {
      radio.disabled = false
    })
  }
  if (elements.defaultSelect) {
    elements.defaultSelect.disabled = false
  }
}



// WEBPACK FOOTER //
// ./src/js/woocommerce/CalculatePrice.js